import { AssetFields } from '../Asset/query';
export const CategoryBannerFields = `
{
    display_title
    subtitle
    button_url
    button_label
    background_image ${AssetFields(960, 450)}
}`;
